import { render, staticRenderFns } from "./commerceEditDialog.vue?vue&type=template&id=59ad7fb2&scoped=true&"
import script from "./commerceEditDialog.vue?vue&type=script&lang=js&"
export * from "./commerceEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./commerceEditDialog.vue?vue&type=style&index=0&id=59ad7fb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ad7fb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59ad7fb2')) {
      api.createRecord('59ad7fb2', component.options)
    } else {
      api.reload('59ad7fb2', component.options)
    }
    module.hot.accept("./commerceEditDialog.vue?vue&type=template&id=59ad7fb2&scoped=true&", function () {
      api.rerender('59ad7fb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/commerceEditDialog.vue"
export default component.exports